import React, { useEffect, useRef, useState } from 'react';
import searchBar from '../../assets/img/icon/searchBtn.png';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import _ from 'lodash';
import SearchList from './SearchList';
import dateSetting from '../../utils/dateSetting';
import Form from 'react-bootstrap/Form';
// import { withTranslation } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import PlayerTypeButton from './PlayerTypeButton';
import LeagueTypeButton from './LeagueTypeButton';

function SearchBar() {
    const [cookies] = useCookies(['hiball_token']);
    let [playerArr, setPlayerArr] = useState([]);
    let inputRef = useRef();
    let listRef = useRef();
    const { i18n, t } = useTranslation();
    const [currLang, setCurrLang] = useState(localStorage.getItem('language'));

    let teamIdArr = [1001, 2001, 3001, 4001, 5001, 6001, 7001, 8001, 9001, 10001];
    let rookieArr = ['정우주','권민규','한지윤','배승수','이동영','박상현','이지성','엄상현','엄요셉','최주원','이민재','박부성','이승현'];

    useEffect(() => {
        searchEvent();
        i18n.changeLanguage(currLang);
    }, []);

    function searchEvent() {
        document.addEventListener('click', (event) => {
            if(event.target.id !== 'searchInput') {
                listRef.current.style.display = 'none';
            }
        });
    }

    function formSubmitHandler(event) {
        let value = inputRef.current.value;
        try {
            validationFunc(value);
            searchFunc(value);
        } catch(err) {

        }

        event.preventDefault();
    }

    function validationFunc(playerName) {
        if(isNaN(playerName)) { // string
            let rc = '[a-z|A-Z|\*|\?|\!|\@|\#|\$|\%|\^|\&]+';
            let reg = new RegExp(rc);
            let t = reg.exec(playerName);
        
            if(t != null) {
                alert("한글만 입력가능합니다.");
                throw new Error("한글만 입력가능합니다.");
            }
        
            if(playerName.length < 2) {
                alert('검색 선수명이 최소 2글자 이상이어야 합니다.');
                throw new Error('검색 선수명이 최소 2글자 이상이어야 합니다.')
            }
        } else { //number
            
        }        
    }
    
    function searchFunc(playerName) {
        let dateObj = dateSetting();
        let params = {
            recordType: 'profileService',
            recordName: 'playerProfile',
            authToken: JSON.stringify(cookies['hiball_token']),
            seasons: dateObj['season']
        }

        if(isNaN(playerName)) { //string
            params['membersName'] = playerName;
        } else { //number
            params['backNumber'] = playerName;
        }
    
        let searchProfile = axios({
            url: `${process.env.REACT_APP_API_URL}`, params
        });
        
        Promise.all([
            searchProfile
        ]).then(value => {
            let profiles = value[0]['data']['result'];

            // console.log(profiles);
            
            let filteredProfiles = _.filter(profiles, function(i){
                if(teamIdArr.indexOf(i.teamId) > -1){
                    return true;
                } else {
                    return false;
                }
            })

            // console.log(filteredProfiles);

            searchProcess(filteredProfiles, playerName);
        })
    }

    function searchProcess(profiles, playerName) {
        let length = searchDataValidation(profiles, playerName);
        
        if(length == 1) {
            onePlayerProccess(profiles[0]);
        } else {
            oneMorePlayerProcess(profiles);
        }
    }

    function searchDataValidation(profiles, playerName) {
        if(profiles.length <= 0) {
            if(rookieArr.indexOf(playerName) > -1) {
                alert("등록되지 않은 선수입니다.(25년 신규선수입니다)");
                throw new Error("등록되지 않은 선수입니다.(25년 신규선수입니다)")
            } else {
                alert("등록되지 않은 선수 입니다.");
                throw new Error("등록되지 않은 선수 입니다.");
            }
        }
        return profiles.length;
    }

    function onePlayerProccess(profile) {
        let playerId = profile.membersId;
        let positionTypeCode = profile.positionTypeCode;
        let positionType = positionCheck(positionTypeCode);
        let leagueType = 'major';

        window.location.href = `/${leagueType}/${positionType}/${playerId}`;
    }

    function oneMorePlayerProcess(profiles) {
        setPlayerArr(profiles);
        listRef.current.style.display = 'inline-block';
    }

    function positionCheck(positionTypeCode) {
        if(positionTypeCode == 5201 || positionTypeCode == 5211) return 'pitcher';
        else return 'batter';
    }

    function changeUseLangHandler(evt) {
        let useLang = evt.target.value;
        i18n.changeLanguage(useLang);
        localStorage.setItem("language", useLang);
        setCurrLang(useLang);
        window.location.reload();
    }

    return (
        <div id="searchBar">
            <Form.Group onChange={changeUseLangHandler} style={{width:"14%", float:"left", marginLeft:"5px"}}>
                <Form.Select id='useLang' size='sm' defaultValue={currLang}>
                    <option value={"kr"}>한국어</option>
                    <option value={"en"}>English</option>
                </Form.Select>
            </Form.Group>
            <LeagueTypeButton/>
            {/* <PlayerTypeButton/> */}
            <form id="searchForm" onSubmit={formSubmitHandler}>
                <input type="text" placeholder={currLang === 'en' ? "Enter Player Name" : "선수명을 입력하세요."} ref={inputRef} />
                <div className="searchIconWrap">
                    <button id="searchPlayerBtn" type="submit" onSubmit={formSubmitHandler}>
                        <img src={searchBar} alt="#"/>
                    </button>
                </div>
            </form>
            <div className="search_player_list_container" style={{display:'none'}} ref={listRef}>
                <div className="search_player_list_conatiner_title">
                    검색 선수
                </div>
                <div className="search_list_area" id="search_list_area">
                    { 
                    playerArr.length !== 0 && 
                    <SearchList data={playerArr} />
                    }
                </div>
            </div>
        </div>        
    )
}



export default SearchBar;